import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { triggerFetchRechargeInsightsAPI } from "../../../redux/actions/rechargeSalesAction";
import config from "../../../utils/config";
import { getPartnerRoleTypesForInsights } from "../../../utils/rechargeSalesInsights";
import RechargeSalesInsightsView from "../../../views/rechargeSales/insights/rechargeSalesInsightsView";

const INSIGHTS_ENDPOINTS = {
  daily: "pams-insights/metrics/daily-trends",
  weekly: "pams-insights/metrics/weekly-trends",
  monthly: "pams-insights/metrics/monthly-trends",
  mtdLmtd: "pams-insights/metrics/trends-mtd-lmtd",
};

function buildPayload(filterValue, section, metricType) {
  const partnerId =
    filterValue.orgId && filterValue.orgId !== ""
      ? filterValue.orgId
      : (filterValue.selectedRole &&
          filterValue.selectedRole.split(" - ")[2]) ||
        "";
  const partnerRoleName = filterValue.selectedPartnerRoleName || "";
  const partnerRoleTypes = getPartnerRoleTypesForInsights(
    partnerRoleName,
    section,
  );

  const base = {
    partner_id: String(partnerId),
    partner_role_types: partnerRoleTypes,
    module_id: "RECHARGE",
    sales_type: section,
  };

  switch (metricType) {
    case "daily":
      return { ...base, days: 30 };
    case "weekly":
      return { ...base, weeks: 12 };
    case "monthly":
      return { ...base, months: 3 };
    case "mtdLmtd":
      return base;
    default:
      return base;
  }
}

export default function RechargeSalesInsights(props) {
  const dispatch = useDispatch();
  const { filterValue, section } = props;
  const { rechargeInsights } = useSelector(
    (state) => state.rechargeSalesReducer,
  );
  const { headerSelectedDateFrom, headerSelectedDateTo } = useSelector(
    (state) => state.homeReducer,
  );
  const previousKeyRef = useRef(null);

  useEffect(() => {
    if (!filterValue || !section) return;

    const partnerRoleTypes = getPartnerRoleTypesForInsights(
      filterValue.selectedPartnerRoleName || "",
      section,
    );

    const partnerId =
      filterValue.orgId && filterValue.orgId !== ""
        ? filterValue.orgId
        : (filterValue.selectedRole &&
            filterValue.selectedRole.split(" - ")[2]) ||
          "";
    // Include date range in key so Set-button date changes trigger a re-fetch
    const effectKey = `${partnerId}_${filterValue.selectedPartnerRoleName || ""}_${section}_${headerSelectedDateFrom || ""}_${headerSelectedDateTo || ""}`;
    if (previousKeyRef.current === effectKey) return;
    previousKeyRef.current = effectKey;

    const baseUrl = config.apiBasePath.baseIp;

    Object.keys(INSIGHTS_ENDPOINTS).forEach((metricType) => {
      const url = `${baseUrl}${INSIGHTS_ENDPOINTS[metricType]}`;
      const params = buildPayload(filterValue, section, metricType);
      const extraData = `${section}_${metricType}`;

      dispatch(
        triggerFetchRechargeInsightsAPI({
          headers: { "Content-Type": "application/json" },
          url,
          params,
          extraData,
        }),
      );
    });
  }, [dispatch, section, filterValue, headerSelectedDateFrom, headerSelectedDateTo]);

  return (
    <RechargeSalesInsightsView
      rechargeInsights={rechargeInsights}
      filterValue={filterValue}
      section={section}
    />
  );
}
